const builderCouponContentDescription = `Purchase Weyerhaeuser Edge Gold™ from your local dealer and receive a first time builder rebate incentive for trying it out! It's as easy as 1, 2, 3.
\n
1.  Purchase Weyerhaeuser Edge Gold from your local dealer.
\n
2.  Complete and submit the online form.
\n
3.  Receive your rebate!`;

const documentLibraryDescription = `Our free document library app gives you quick and direct access to our family of literature and technical documents while you're on the go. Organize documents into virtual binders for each project, job site, or event and easily share a link to a document or binder though text message and/or email.
\n
You can sync your account from our document library at [Weyerhaeuser.com](https://www.weyerhaeuser.com/) with your mobile device to access your binders from anywhere. Don’t have a user account? Create one online at [Weyerhaeuser.com/register](https://www.weyerhaeuser.com/register/) or create your account on the mobile app.
\n
Get started using the Document Library mobile app today!`;

export const sections = [
  {
    name: 'Home',
    link: '/#home',
    color: '#2B2B2B',
  },
  {
    name: 'Builder Coupon',
    link: '/section/builder-coupon',
    imagePreview:
      'https://temporal-assets-storage.s3.amazonaws.com/General/builder-coupon.png',
    imagePreviewMobile:
      'https://temporal-assets-storage.s3.amazonaws.com/General/builder-coupon-mobile.png',
    color: '#015779',
    buttonLabel: 'SEE',
    content: {
      title: 'Builder Coupon',
      mobileTitle: '',
      description: builderCouponContentDescription,
      imageSrc:
        'https://temporal-assets-storage.s3.amazonaws.com/Content/builder-coupon.png',
      mobileImageSrc:
        'https://temporal-assets-storage.s3.amazonaws.com/Content/builder-coupon-mobile.png',
      button: {
        label: 'Click for Rebate Form',
        link: 'https://temporal-assets-storage.s3.amazonaws.com/Edge+Gold+Coupon+2021.pdf',
      },
      storeButtons: null,
    },
    subsections: [],
    viewType: 'GENERAL',
  },
  {
    name: 'Social Media',
    link: '/section/social-media',
    defaultSubsection: 'sample-posts',
    imagePreview:
      'https://temporal-assets-storage.s3.amazonaws.com/General/social-media.png',
    imagePreviewMobile:
      'https://temporal-assets-storage.s3.amazonaws.com/General/social-media-mobile.png',
    color: '#FFD100',
    buttonLabel: 'ENGAGE',
    content: [],
    subsections: [
      {
        id: 'sample-posts',
        label: 'Sample Posts',
        link: '/section/social-media/sample-posts',
        description:
          'Connect with your customers by copying and sharing these scripted social media posts',
        content: [
          {
            id: 'sample-post-01',
            title: 'Sample Post 01',
            description:
              'From starter homes to dream homes, Weyerhaeuser has the floor panels to meet your needs — Weyerhaeuser Edge Gold™ enhanced floor panels',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/P1011115.png',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/P1011115-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'sample-post-02',
            title: 'Sample Post 02',
            description: `Give yourself an Edge. With the easy fit T&G, Weyerhaeuser Edge Gold™ floor panels make installation fast and easy.`,
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/photo-EG-panels+at+jobsite.png',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/photo-EG-panels+at+jobsite-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'sample-post-03',
            title: 'Sample Post 03',
            description:
              'From starter homes to dream homes, Weyerhaeuser has the floor panels to meet your needs — Weyerhaeuser Edge Gold™ enhanced floor panels',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/_DSC3530.jpg',
            type: 'image/png',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/_DSC3530-thumb.png',
            },
            viewType: 'FILE',
          },
          {
            id: 'sample-post-04',
            title: 'Sample Post 04',
            description:
              'To increase your customers satisfaction on floor performance, use Weyerhaeuser Edge Gold™ in conjunction with Trus Joist® TJI® joists for additional TJ-Pro™ Rating points.',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/floor-system+Pro+Rating+Edge+Gold.png',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/floor-system+Pro+Rating+Edge+Gold-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'sample-post-05',
            title: 'Sample Post 05',
            description:
              'To increase your customers satisfaction on floor performance, use Weyerhaeuser Edge Gold™ in conjunction with Trus Joist® TJI® joists for additional TJ-Pro™ Rating points.',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/NRWA28.jpg',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/NRWA28-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
        ],
      },
      {
        id: 'osb-videos',
        label: 'OSB Videos',
        link: '/section/social-media/osb-videos',
        description:
          'Enhance your post by downloading and sharing one of these videos',
        content: [
          {
            id: 'osb-videos-01',
            title: 'OSB Mill Tour',
            description:
              'Weyerhaeuser Edge Gold™ enhanced floor panels come with a self-draining technology called Down Pore® that reduces rainwater ponding and ice build up on the jobsite.',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/Weyerhaeuser+OSB+Mill+Tour-thumb.png',
            },
            src: 'https://temporal-assets-storage.s3.amazonaws.com/Videos/Weyerhaeuser+OSB+Mill+Tour.mp4',
            type: 'video/mp4',
            viewType: 'GENERAL',
          },
          {
            id: 'osb-videos-02',
            title: 'Down Pore Self-Draining Technology',
            description: `Give yourself an Edge.
            With the easy fit T&G, Weyerhaeuser Edge Gold™ floor panels make installation fast and easy.`,
            imageSrc:
              '/content/thumb/Weyerhaeuser_Introduces_DownPore-thumb.png',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/Weyerhaeuser_Introduces_DownPore-thumb.png',
            },
            src: 'https://temporal-assets-storage.s3.amazonaws.com/Videos/Weyerhaeuser_Introduces__DownPore.mov',
            type: 'video/mp4',
            viewType: 'GENERAL',
          },
          {
            id: 'osb-videos-03',
            title: 'The Subfloor Trus Joist Floor Installation',
            description:
              'From starter homes to dream homes, Weyerhaeuser has the floor panels to meet your needs — Weyerhaeuser Edge Gold™ enhanced floor panels',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/The_Subfloor_Trus_Joist_Floor_Installation_Guide-thumb.png',
            },
            src: 'https://temporal-assets-storage.s3.amazonaws.com/Videos/The_Subfloor_-_Trus_Joist_EWP_Floor_Installation_Guide.mp4',
            type: 'video/mp4',
            viewType: 'GENERAL',
          },
          {
            id: 'osb-videos-04',
            title: 'The Subfloor Trus Joist Floor Installation-Spanish',
            description:
              'From starter homes to dream homes, Weyerhaeuser has the floor panels to meet your needs — Weyerhaeuser Edge Gold™ enhanced floor panels',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/The_Subfloor_Trus_Joist_Floor_Installation_Guide-thumb.png',
            },
            src: 'https://temporal-assets-storage.s3.amazonaws.com/Videos/Final+Subfloor+Spanish+8-13-14+Rev.mp4',
            type: 'video/mp4',
            viewType: 'GENERAL',
          },
        ],
      },
      {
        id: 'photos-logos',
        label: 'Photos/Logos',
        link: '/section/social-media/photos-logos',
        description:
          'Enhance your post by downloading and sharing one of these videos',
        content: [
          {
            id: 'photos-logo-01',
            title: 'Edge Gold™ Enhanced Floor Panels Zoomed',
            description:
              'Close up of Edge Gold™ Enhanced Floor Panels at a Jobsite',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/7U8A5823.jpg',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/7U8A5823-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'photos-logo-02',
            title: 'Edge Gold™ Enhanced Floor Panels at a Jobsite',
            description:
              'Weyerhaeuser Edge Gold™ Enhanced Floor Panels at a HDH Jobsite with city in the background',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/7U8A5825.jpg',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/7U8A5825-thumbP.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'photos-logo-03',
            title:
              ' Edge Gold™ Enhanced Floor Panels over Trus Joist® TJI® joists',
            description:
              ' Builder nailing down Weyerhaeuser Edge Gold™ Enhanced Floor Panels over Trus Joist® TJI® joists ',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/_DSC3515_color.jpg',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/_DSC3515_color-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'photos-logo-04',
            title: 'Edge Gold™ Digital Ad',
            description: 'Edge Gold™ Digital Ad in 300x250 Retina',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/WEY_DigitalAds_EdgeGold_300x250_10-20-retina.jpg',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/_DSC3515-thumb.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'photos-logo-05',
            title: 'Edge Gold™ Logo (eps)',
            description: 'Edge Gold™ Logo in EPS format',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/EdgeGold_4c.eps',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/Group+1908.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
          {
            id: 'photos-logo-06',
            title: ' Edge Gold™ Logo (png)',
            description: 'Edge Gold™ Logo in png with transparent background',
            src: 'https://temporal-assets-storage.s3.amazonaws.com/download-assets/EdgeGold_Logo.png',
            thumbnail: {
              imageSrc:
                'https://temporal-assets-storage.s3.amazonaws.com/thumbnails/Group+1908.png',
            },
            type: 'image/png',
            viewType: 'FILE',
          },
        ],
      },
    ],
    viewType: 'WITH_SUBSECTIONS',
  },
  {
    name: 'Document Library',
    link: '/section/document-library',
    imagePreview:
      'https://temporal-assets-storage.s3.amazonaws.com/General/document-library.png',
    imagePreviewMobile:
      'https://temporal-assets-storage.s3.amazonaws.com/General/document-library-mobile.png',
    color: '#008457',
    buttonLabel: 'DISCOVER',
    subsections: [],
    viewType: 'GENERAL',
    content: {
      title: 'Discover more with our literature',
      description: documentLibraryDescription,
      imageSrc:
        'https://temporal-assets-storage.s3.amazonaws.com/Content/document-library.png',
      mobileImageSrc:
        'https://temporal-assets-storage.s3.amazonaws.com/Content/document-library-mobile.png',
      button: null,
      storeButtons: {
        appStore:
          'https://apps.apple.com/us/app/weyerhaeuser-document-library/id738760952',
        googlePlay:
          'https://play.google.com/store/apps/details?id=com.weyerhaeuser.wylibrary',
      },
    },
  },
  {
    name: 'Marketing',
    link: '/section/marketing',
    imagePreview:
      'https://temporal-assets-storage.s3.amazonaws.com/General/marketing.png',
    imagePreviewMobile:
      'https://temporal-assets-storage.s3.amazonaws.com/General/marketing-mobile.png',
    color: '#8B816C',
    buttonLabel: 'SELL',
    content: {
      title: 'Marketing Inquiries',
      description:
        "We welcome your advertising or marketing request, but please know we can't respond to every inquiry. If we see a fit with your product or service we'll respond in a timely manner. Thank you for your interest in Weyerhaeuser Company.",
      imageSrc:
        'https://temporal-assets-storage.s3.amazonaws.com/Content/marketing.png',
      mobileImageSrc:
        'https://temporal-assets-storage.s3.amazonaws.com/Content/marketing-mobile.png',
      button: {
        label: 'CLICK TO REQUEST INFO',
        link: 'https://www.weyerhaeuser.com/company/contact-us-locations/advertising-and-marketing-inquiries/',
      },
      storeButtons: null,
    },
    subsections: [],
    viewType: 'GENERAL',
  },
];
export const storeButtons = [
  {
    id: 'appStore',
    srcImage:
      'https://temporal-assets-storage.s3.amazonaws.com/Content/appleStore.png',
  },
  {
    id: 'googlePlay',
    srcImage:
      'https://temporal-assets-storage.s3.amazonaws.com/Content/googleStore.png',
  },
];
export const socialMedia = [
  { id: 'twitter', link: 'https://twitter.com/weyerhaeuser' },
  {
    id: 'facebook',
    link: 'https://www.facebook.com/WeyerhaeuserCompany',
  },
  {
    id: 'linkedin',
    link: 'https://www.linkedin.com/company/weyerhaeuser/',
  },
  {
    id: 'instagram',
    link: 'https://www.instagram.com/weyerhaeuser/',
  },
];
